import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';

// Gallery images data - Add your images here
const galleryImages = [
  { 
    id: 1, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/2zsbm99b_devang%20sampat%20%2C%20vishek%20chauhan%20%26%20amit%20sharma.png', 
    alt: 'Devang Sampat, Vishek Chauhan & Amit Sharma', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 2, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/nz5e4sh4_Amala%20Akkineni%20%26%20%20Salil%20Murthy%20.png', 
    alt: 'Amala Akkineni & Salil Murthy', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 3, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/wne2degz_Andrea%20.png', 
    alt: 'Andrea', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 4, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/zg4qonv0_anupama%20chopra%20.png', 
    alt: 'Anupama Chopra', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 5, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/suqdz9t4_anurag%20kashyap%20.png', 
    alt: 'Anurag Kashyap', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 6, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/l25pzr0e_devanshu%20%26%20skand%20.png', 
    alt: 'Devanshu & Skand', 
    podcast: 'Two Boys One Cup' 
  },
  { 
    id: 7, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/t42pysid_fijioy%20%26%20kubra%20.png', 
    alt: 'Fijioy & Kubra', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 8, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/xs3bqjwz_gautam%20thakar%20%26%20mandvi%20.png', 
    alt: 'Gautam Thakar & Mandvi', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 9, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/8flc1utj_gulshan%20%26%20umesh%20.png', 
    alt: 'Gulshan & Umesh', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 10, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/01x17bp8_jammy%20pants.png', 
    alt: 'Jammy Pants', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 11, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/ezain9i6_jizzy%20paji.png', 
    alt: 'Jizzy Paji', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 12, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/c8n4kmrm_kanupriya%20pandit%20.png', 
    alt: 'Kanupriya Pandit', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 13, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/c2f6jh0w_karan%20wahi%20%26%20santoshi%20jaddu.png', 
    alt: 'Karan Wahi & Santoshi Jaddu', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 14, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/ycmv1psu_kavish%20sinha.png', 
    alt: 'Kavish Sinha', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 15, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/nohukr77_maninee%20de.png', 
    alt: 'Maninee De', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 16, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/u8oqonov_mukesh%20chhabra.png', 
    alt: 'Mukesh Chhabra', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 17, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/vgwc3anm_nitin%20miranni%20.png', 
    alt: 'Nitin Miranni', 
    podcast: 'Two Boys One Cup' 
  },
  { 
    id: 18, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/v26hgmcm_parany%20%26%20sehaj.png', 
    alt: 'Parany & Sehaj', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 19, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/kt7axfq3_pavitra%20%26%20dudeja.png', 
    alt: 'Pavitra & Dudeja', 
    podcast: 'Two Boys One Cup' 
  },
  { 
    id: 20, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/ixmlqb5k_pratab%20%26%20shreya.png', 
    alt: 'Pratab & Shreya', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 21, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/6s6m9w4x_R%20madhav%20.png', 
    alt: 'R Madhav', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 22, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/xmxu42l4_ram%20gopla%20verma%20.png', 
    alt: 'Ram Gopal Varma', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 23, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/5kr0yrqi_remo%20%26%20diana%20.png', 
    alt: 'Remo & Diana', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 24, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/b1x56zpb_Rohan%20Joshi%20%26%20%20Saqib%20Saleem%20Pathan.png', 
    alt: 'Rohan Joshi & Saqib Saleem Pathan', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 25, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/2hj8mvel_Rohan%20Joshi%20%26%20Saqib%20Saleem%20Pathan.png', 
    alt: 'Rohan Joshi & Saqib Saleem Pathan', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 26, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/fczf3mae_salonay%20.png', 
    alt: 'Salonay', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 27, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/sh4bfucs_Screenshot%202025-12-11%20130405.png', 
    alt: 'Guest', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 28, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/a90pmj3r_shahib%20bali.png', 
    alt: 'Shahib Bali', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 29, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/6fxaiong_shekhar%20ravijani%20.png', 
    alt: 'Shekhar Ravijani', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 30, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/7ea8ouok_shiva.png', 
    alt: 'Shiva', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 31, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/2ydlwbma_Sophie%20Choudry%20%26%20PK%20Chug%20.png', 
    alt: 'Sophie Choudry & PK Chug', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 32, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/6aptse5u_Amala%20Akkineni%20%26%20Salil%20Murthy.png', 
    alt: 'Amala Akkineni & Salil Murthy', 
    podcast: 'The Happy Pawdcast' 
  },
  { 
    id: 33, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/c35z45tf_amol%20parashan%20.png', 
    alt: 'Amol Parashar', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 34, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/7mqwlp1m_amol%20parashar%20.png', 
    alt: 'Amol Parashar', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 35, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/s9zvzuc4_cryus%20.png', 
    alt: 'Cyrus', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 36, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/0qhve5bv_harsh%20beniwal%20.png', 
    alt: 'Harsh Beniwal', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 37, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/hvckq09d_kabir%20khan.png', 
    alt: 'Kabir Khan', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 38, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/xthi7yk9_karan%20ahuja%20.png', 
    alt: 'Karan Ahuja', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 39, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/0kixul2a_hansal%20mehta%20.png', 
    alt: 'Hansal Mehta', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 40, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/ea6lpxoa_harleen%20sethi%20%20.png', 
    alt: 'Harleen Sethi', 
    podcast: 'Cupgraded' 
  },
  { 
    id: 41, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/0ejv2bqy_paurl%20gulati.png', 
    alt: 'Paurl Gulati', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 42, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/45elw43e_kim%20sharma%20%26%20rajeev%20masand.png', 
    alt: 'Kim Sharma & Rajeev Masand', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 43, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/s7a93xni_kubra%20sait.png', 
    alt: 'Kubra Sait', 
    podcast: 'Two Girls Two Cups' 
  },
  { 
    id: 44, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/jsqmzyb1_mandvi%20.png', 
    alt: 'Mandvi', 
    podcast: 'The Filmy Hustle' 
  },
  { 
    id: 45, 
    src: 'https://customer-assets.emergentagent.com/job_rosepod-landing/artifacts/g5z88v91_monika%20shergill%20.png', 
    alt: 'Monika Shergill', 
    podcast: 'The Filmy Hustle' 
  },
];

const GalleryPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState(12);

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  const logoUrl = "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/bdhzg2gi_Rosepod%20logo%20white%20color.png";

  const openLightbox = (index) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  const goToPrevious = () => {
    setSelectedImage((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const goToNext = () => {
    setSelectedImage((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'ArrowRight') goToNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  const loadMore = () => {
    setLoadedImages((prev) => Math.min(prev + 12, galleryImages.length));
  };

  const displayedImages = galleryImages.slice(0, loadedImages);

  return (
    <div className="min-h-screen bg-[#04101C]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-40 bg-[#04101C]/90 backdrop-blur-lg border-b border-[#00C4CC]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <img src={logoUrl} alt="Rosepod" className="h-10 md:h-12 w-auto" />
            </Link>
            <Link
              to="/"
              className="flex items-center gap-2 text-[#F5FDFF]/70 hover:text-[#00E08F] transition-colors"
            >
              <ArrowLeft size={20} />
              <span className="hidden sm:inline">Back to Home</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#00C4CC]/10 rounded-full blur-[150px]" />
          <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#00E08F]/10 rounded-full blur-[120px]" />
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-12">
            <h1
              className={`text-4xl md:text-5xl lg:text-6xl font-bold text-[#F5FDFF] mb-6 transition-all duration-700 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Our <span className="bg-gradient-to-r from-[#00C4CC] via-[#00E08F] to-[#FFF7AE] bg-clip-text text-transparent">Gallery</span>
            </h1>
            <p
              className={`text-[#F5FDFF]/60 text-lg max-w-2xl mx-auto transition-all duration-700 delay-200 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Behind the mic moments — capturing the faces and stories that make our podcasts special.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid - Pinterest/Masonry Style */}
      <section className="pb-24 px-4">
        <div className="max-w-7xl mx-auto">
          {galleryImages.length === 0 ? (
            // Empty state
            <div className="text-center py-20">
              <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-[#00C4CC]/10 flex items-center justify-center">
                <ZoomIn size={40} className="text-[#00C4CC]" />
              </div>
              <h3 className="text-2xl font-bold text-[#F5FDFF] mb-4">Gallery Coming Soon</h3>
              <p className="text-[#F5FDFF]/60 max-w-md mx-auto">
                We're curating amazing moments from our podcast sessions. Check back soon for exclusive behind-the-scenes content!
              </p>
            </div>
          ) : (
            <>
              {/* Masonry Grid */}
              <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
                {displayedImages.map((image, index) => (
                  <div
                    key={image.id}
                    className={`break-inside-avoid group cursor-pointer transition-all duration-500 ${
                      isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                    style={{ transitionDelay: `${(index % 12) * 50}ms` }}
                    onClick={() => openLightbox(index)}
                  >
                    <div className="relative overflow-hidden rounded-2xl bg-[#0a1929]">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-110"
                        loading="lazy"
                      />
                      {/* Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-[#04101C] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                          {image.alt && (
                            <p className="text-[#F5FDFF] font-semibold text-sm mb-1">{image.alt}</p>
                          )}
                          {image.podcast && (
                            <p className="text-[#00E08F] text-xs">{image.podcast}</p>
                          )}
                        </div>
                      </div>
                      {/* Zoom Icon */}
                      <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#04101C]/70 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
                        <ZoomIn size={18} className="text-[#00E08F]" />
                      </div>
                      {/* Border Glow on Hover */}
                      <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#00C4CC]/50 group-hover:shadow-[0_0_20px_rgba(0,196,204,0.3)] transition-all duration-300" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Load More Button */}
              {loadedImages < galleryImages.length && (
                <div className="text-center mt-12">
                  <button
                    onClick={loadMore}
                    className="px-8 py-4 rounded-full bg-gradient-to-r from-[#00C4CC] to-[#00E08F] text-[#04101C] font-bold hover:shadow-[0_0_30px_rgba(0,224,143,0.4)] transition-all duration-300 hover:scale-105"
                  >
                    Load More Photos
                  </button>
                  <p className="text-[#F5FDFF]/40 text-sm mt-4">
                    Showing {loadedImages} of {galleryImages.length} photos
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 z-50 bg-[#04101C]/95 backdrop-blur-lg flex items-center justify-center"
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-[#F5FDFF]/10 hover:bg-[#F5FDFF]/20 flex items-center justify-center text-[#F5FDFF] transition-all duration-300 z-10"
          >
            <X size={24} />
          </button>

          {/* Previous Button */}
          <button
            onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
            className="absolute left-4 md:left-8 w-12 h-12 rounded-full bg-[#F5FDFF]/10 hover:bg-[#F5FDFF]/20 flex items-center justify-center text-[#F5FDFF] transition-all duration-300 z-10"
          >
            <ChevronLeft size={28} />
          </button>

          {/* Next Button */}
          <button
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
            className="absolute right-4 md:right-8 w-12 h-12 rounded-full bg-[#F5FDFF]/10 hover:bg-[#F5FDFF]/20 flex items-center justify-center text-[#F5FDFF] transition-all duration-300 z-10"
          >
            <ChevronRight size={28} />
          </button>

          {/* Image Container */}
          <div 
            className="max-w-5xl max-h-[85vh] mx-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[selectedImage]?.src}
              alt={galleryImages[selectedImage]?.alt}
              className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
            />
            {/* Image Info */}
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#04101C] to-transparent rounded-b-lg">
              {galleryImages[selectedImage]?.alt && (
                <p className="text-[#F5FDFF] font-semibold text-lg">{galleryImages[selectedImage].alt}</p>
              )}
              {galleryImages[selectedImage]?.podcast && (
                <p className="text-[#00E08F] text-sm mt-1">{galleryImages[selectedImage].podcast}</p>
              )}
              <p className="text-[#F5FDFF]/40 text-sm mt-2">
                {selectedImage + 1} / {galleryImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
